enum EFormId {
  ItemDetails = "itemDetails",
  PricingInfo = "pricingInfo",
  ProductDetails = "productDetails",
  ProductMatch = "productMatch",
  Review = "review",
}

export default EFormId;
